/**
 * Business logic per Users autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import usersService from '../services/usersService';
import type { ApplicationUserAutocompleteResult } from '../models/applicationUser';
import type { BaseAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

/**
 * Logica pura per ricerca users autocomplete
 */
export async function getUsersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: BaseAutocompleteOptions = {},
): Promise<ApplicationUserAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,userName,email,displayName,active',
		count: true,
		top: 20,
		orderBy: ['active desc', 'userName'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			'tolower(userName)': { contains: searchString },
		});
	} else if (id) {
		context.filter!.and!.push({
			id: { eq: id },
		});
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	const result = await usersService.getUsers(buildQuery(context));
	return result.value;
}
